
import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'

import {
  SAVE_AUTOMATION_REQUEST, SAVE_AUTOMATION_RESPONSE,
  LIST_UNIT_AUTOMATIONS_REQUEST, LIST_UNIT_AUTOMATIONS_RESPONSE,
  ADD_UNIT_AUTOMATION_REQUEST, ADD_UNIT_AUTOMATION_RESPONSE,
  REMOVE_UNIT_AUTOMATION_REQUEST, REMOVE_UNIT_AUTOMATION_RESPONSE,
} from '../constants'

export function addUnitAutomation(id, automation) {
  const unitId = parseInt(id, 10)
  return (dispatch) => {
    dispatch({ type: ADD_UNIT_AUTOMATION_REQUEST, unitId, automation })
    axios.post(`${CONFIG.apiBase}/units/${unitId}/automations`, automation).then((response) => {
      dispatch({
        type: ADD_UNIT_AUTOMATION_RESPONSE,
        unitId,
        automation: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function removeUnitAutomation(id, automationId) {
  const unitId = parseInt(id, 10)
  return (dispatch) => {
    dispatch({ type: REMOVE_UNIT_AUTOMATION_REQUEST, unitId, automationId })
    axios.delete(`${CONFIG.apiBase}/units/${unitId}/automations/${automationId}`).then(() => {
      dispatch({
        type: REMOVE_UNIT_AUTOMATION_RESPONSE,
        unitId,
        automationId,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function listUnitAutomations(id) {
  const unitId = parseInt(id, 10)
  return (dispatch, getState) => {
    if (isCachedItem(getState().automationsByUnit, unitId)) {
      return
    }
    dispatch({ type: LIST_UNIT_AUTOMATIONS_REQUEST, unitId })

    axios.get(`${CONFIG.apiBase}/units/${unitId}/automations`).then((response) => {
      dispatch({
        type: LIST_UNIT_AUTOMATIONS_RESPONSE,
        unitId,
        automations: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function saveAutomation(automation) {
  return (dispatch) => {
    dispatch({ type: SAVE_AUTOMATION_REQUEST, automation })
    axios.put(`${CONFIG.apiBase}/automations/${automation.id}`, automation).then((response) => {
      dispatch({
        type: SAVE_AUTOMATION_RESPONSE,
        automation: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}
